export default "__VITE_ASSET__jXxnY$9D__"